"use strict";

/**
 * Статусы модерации
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModerationStatusEnum = void 0;
var ModerationStatusEnum;
(function (ModerationStatusEnum) {
  /** Снято с модерации */
  ModerationStatusEnum[ModerationStatusEnum["unmoderated"] = -1] = "unmoderated";
  /** На модерации */
  ModerationStatusEnum[ModerationStatusEnum["default"] = 0] = "default";
  /** Одобрено */
  ModerationStatusEnum[ModerationStatusEnum["approved"] = 1] = "approved";
  /** Отклонено с возможностью повторной отправки */
  ModerationStatusEnum[ModerationStatusEnum["softDeclined"] = 2] = "softDeclined";
  /** Отклонено без возможности повторной отправки */
  ModerationStatusEnum[ModerationStatusEnum["hardDeclined"] = 3] = "hardDeclined";
})(ModerationStatusEnum = exports.ModerationStatusEnum || (exports.ModerationStatusEnum = {}));
